//set an array of fields and an array of fields to disabled in the form
const disbleFields = (fields: any[], fieldsToDisabled: any[]) => {
    return fields.forEach((section: any) => {
        section.fields?.forEach((field: any) => {
            fieldsToDisabled.forEach((fieldToDisabled: any) => {
                if (field.name === fieldToDisabled) {
                    field.disabled = true;
                }
            });
        });
    });
};

export default disbleFields;
